import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShirt } from "@fortawesome/free-solid-svg-icons";
import { imageQueueLabel, imageQueueWait } from "../../utils/imageQueueLabel";
import styles from "./Wardrobe.module.css";
import { categoryLabel, imageUrl } from "./wardrobeConstants";

function ClothingItemCard({ item, onClick }) {
  const queued = ["queued", "pending", "processing"].includes(item.image_generation_status);
  return (
    <button className={styles.card} type="button" onClick={() => onClick(item)}>
      <span className={styles.cardImage}>
        {queued ? (
          <span className={styles.queuePlaceholder}><FontAwesomeIcon icon={faShirt} aria-hidden="true" /><strong>Fila de Processamento</strong><small>{imageQueueLabel(item.image_queue)}</small><small>{imageQueueWait(item.image_queue)}</small></span>
        ) : item.image_url && item.image_origin !== "source_photo" ? (
          <img src={imageUrl(item.image_url)} alt={item.name} />
        ) : (
          <span className={styles.placeholder} aria-label="Peça sem imagem">
            <FontAwesomeIcon icon={faShirt} aria-hidden="true" />
          </span>
        )}
      </span>
      <span className={styles.cardBody}>
        <strong>{item.name}</strong>
        {item.image_generation_status === "failed" && <span className={styles.metadata}>Não foi possível gerar a imagem</span>}
        <span className={styles.category}>{categoryLabel(item.category)}</span>
        {(item.color || item.brand) && (
          <span className={styles.metadata}>
            {[item.color, item.brand].filter(Boolean).join(" · ")}
          </span>
        )}
      </span>
    </button>
  );
}

export default ClothingItemCard;
